import React, { useState, useEffect } from 'react';
function PhotoViewer(albumId) {
    const [photos, setPhotos] = useState([]);
    const [currIndex, setCurrIndex] = useState(0);
    useEffect(
        () => {
            var url = "/Photo/GetPhotos?photoAlbumId=" + albumId.albumId; // process.env.REACT_APP_APIURL + "GetPhotoAlbums";
            console.log(url);
            console.log(albumId);
            fetch(url).then(res => res.json()).then((data) => {
                console.log(data);
                setPhotos(data);
                console.log(data);
            }).catch(err => alert(err));
        }, [albumId]);
    const Next = (dir) => {
        if (dir === '-') {
            if (currIndex > 0){
                setCurrIndex(currIndex - 1);
            }
        }
        else if (dir === '+') {
            if (currIndex < (photos.length - 1)) {
                setCurrIndex(currIndex + 1);
            }
        }



    }



    return (
        <div className="container">
            <div className="row"  >
                <div className="col-lg-1">
                    <button onClick={() => Next('-')} >-  </button>
                </div>
                <div className="col-lg-1">
                    <button onClick={() => Next('+')} >+  </button>
                </div>
                <div className="col-lg-10">
                    Image {currIndex + 1} of {photos.length    } Pictures
                </div>
            </div>
            <div className="row"  >
                <div className="col-lg-12">
                        {photos.length > 0 && <img alt="" src={photos[currIndex].photoUrl}></img>}
                    </div></div>
            

        </div>);

}

export default PhotoViewer

